import { NgModule } from '@angular/core';


import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { ClipboardModule } from 'ngx-clipboard';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http'; 
import { ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio'; 
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatTabsModule} from '@angular/material/tabs'; 
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { HttpHeadersInterceptor } from '../../interceptors/http-headers.service';
import { FrenchPaginatorIntl } from '../../core/services/french-paginator-intl.service';




import { SharedModule } from '../../shared/shared.module';
import { TarifConfigurationComponent } from './tarif-configuration.component';
import { ListeTarifConfigurationComponent } from './lister/liste-tarif-configuration.component';

/*import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { QuickviewComponent } from './quickview/quickview.component';
import { UserComponent } from './user/user.component';
import { RecentvoucherComponent } from './recentvoucher/recentvoucher.component';
import { RecentclientsComponent } from './recentclients/recentclients.component';
import { CopyrightComponent } from './copyright/copyright.component';
 import { ProfileComponent } from './common/profile/profile.component';

import { BalancealertComponent } from './balancealert/balancealert.component';
import { SplinechartComponent } from './charts/splinechart/splinechart.component';
import { BarchartComponent } from './charts/barchart/barchart.component';
import { PiechartComponent } from './charts/piechart/piechart.component';
import { CreatebankComponent } from './bank/createbank/createbank.component';
import { BalancetransferComponent } from './bank/balancetransfer/balancetransfer.component';
import { CreatepaymentComponent } from './payment/createpayment/createpayment.component';
import { CreatepaymentinvoiceComponent } from './payment/createpaymentinvoice/createpaymentinvoice.component';
import { CreateledgerComponent } from './ledger/createledger/createledger.component';
import { BanklistComponent } from './bank/banklist/banklist.component';
import { PaymentlistComponent } from './payment/paymentlist/paymentlist.component';
import { PaginationComponent } from './common/pagination/pagination.component';
import { LedgerlistComponent } from './ledger/ledgerlist/ledgerlist.component';
import { PaymentlistinvoiceComponent } from './payment/paymentlistinvoice/paymentlistinvoice.component';
import { TransferlistComponent } from './bank/transferlist/transferlist.component';
import { LedgergroupComponent } from './ledger/ledgergroup/ledgergroup.component';
import { DebitlistComponent } from './voucher/debitlist/debitlist.component';
import { CreditlistComponent } from './voucher/creditlist/creditlist.component';
import { PaymentviewpopupComponent } from './popup/paymentviewpopup/paymentviewpopup.component';
import { PaymentinvoicepopupComponent } from './popup/paymentinvoicepopup/paymentinvoicepopup.component';
import { DebitvoucherComponent } from './voucher/debitvoucher/debitvoucher.component';
import { CreditvoucherComponent } from './voucher/creditvoucher/creditvoucher.component';
import { DebitvoucherpopupComponent } from './popup/debitvoucherpopup/debitvoucherpopup.component';
import { CreditvoucherpopupComponent } from './popup/creditvoucherpopup/creditvoucherpopup.component';
import { CreatejournalComponent } from './voucher/createjournal/createjournal.component';
import { JournallistComponent } from './voucher/journallist/journallist.component';
import { JournalpopupComponent } from './popup/journalpopup/journalpopup.component';
import { CompanyComponent } from './company/company/company.component';
import { AddcompanypopupComponent } from './popup/addcompanypopup/addcompanypopup.component';
import { CompanyoverviewpopupComponent } from './popup/companyoverviewpopup/companyoverviewpopup.component';
import { SupplierComponent } from './people/supplier/supplier.component';
import { AddsupplierpopupComponent } from './popup/addsupplierpopup/addsupplierpopup.component';
import { BillerComponent } from './people/biller/biller.component';
import { AddbillerpopupComponent } from './popup/addbillerpopup/addbillerpopup.component';
import { AddvendorpopupComponent } from './popup/addvendorpopup/addvendorpopup.component';
import { VendorComponent } from './people/vendor/vendor.component';
import { CustomerComponent } from './people/customer/customer.component';
import { AddcustomerpopupComponent } from './popup/addcustomerpopup/addcustomerpopup.component';
import { AdduserComponent } from './usermanagement/adduser/adduser.component';
import { UserlistComponent } from './usermanagement/userlist/userlist.component';
import { UserroleComponent } from './usermanagement/userrole/userrole.component';
import { ManagebillComponent } from './bill/managebill/managebill.component';
import { AddbillComponent } from './bill/addbill/addbill.component';
import { AddpaymentpopupComponent } from './popup/addpaymentpopup/addpaymentpopup.component';
import { SendbillpopupComponent } from './popup/sendbillpopup/sendbillpopup.component';
import { TransectionComponent } from './reports/transection/transection.component';
import { AccountsbalanceComponent } from './reports/accountsbalance/accountsbalance.component';
import { TrialbalanceComponent } from './reports/trialbalance/trialbalance.component';
import { IncomereportComponent } from './reports/incomereport/incomereport.component';

import { IncomechartsComponent } from './charts/incomecharts/incomecharts.component';

import { ExpensereportComponent } from './reports/expensereport/expensereport.component';
import { ProfitreportComponent } from './reports/profitreport/profitreport.component';
import { NetincomereportComponent } from './reports/netincomereport/netincomereport.component';
import { BalancesheetComponent } from './reports/balancesheet/balancesheet.component';
import { BilldetailspopupComponent } from './popup/billdetailspopup/billdetailspopup.component';
import { RolepermissionComponent } from './setting/rolepermission/rolepermission.component';
import { BankrolepermissionComponent } from './setting/bankrolepermission/bankrolepermission.component';
import { PaymentrolepermissionComponent } from './setting/paymentrolepermission/paymentrolepermission.component';
import { VoucherrolepermissionComponent } from './setting/voucherrolepermission/voucherrolepermission.component';
import { LedgerrolepermissionComponent } from './setting/ledgerrolepermission/ledgerrolepermission.component';
import { CompanyrolepermissionComponent } from './setting/companyrolepermission/companyrolepermission.component';
import { PeoplerolepermissionComponent } from './setting/peoplerolepermission/peoplerolepermission.component';
import { ReportrolepermissionComponent } from './setting/reportrolepermission/reportrolepermission.component';
import { SettingrolepermissionComponent } from './setting/settingrolepermission/settingrolepermission.component';

import { DashboardiconComponent } from './menuicon/dashboardicon/dashboardicon.component';
import { BankiconComponent } from './menuicon/bankicon/bankicon.component';
import { PaymenticonComponent } from './menuicon/paymenticon/paymenticon.component';
import { VouchericonComponent } from './menuicon/vouchericon/vouchericon.component';
import { LedgericonComponent } from './menuicon/ledgericon/ledgericon.component';
import { BilliconComponent } from './menuicon/billicon/billicon.component';
import { CompanyiconComponent } from './menuicon/companyicon/companyicon.component';
import { SmsiconComponent } from './menuicon/smsicon/smsicon.component';
import { PeopleiconComponent } from './menuicon/peopleicon/peopleicon.component';
import { ReporticonComponent } from './menuicon/reporticon/reporticon.component';
import { ToolsiconComponent } from './menuicon/toolsicon/toolsicon.component';

import { CustomeraddbillComponent } from './bill/customeraddbill/customeraddbill.component';
import { CustomermanagebillComponent } from './bill/customermanagebill/customermanagebill.component';

import { EditprofileiconComponent } from './menuicon/editprofileicon/editprofileicon.component';
import { AppearenceiconComponent } from './menuicon/appearenceicon/appearenceicon.component';
import { LanguageiconComponent } from './menuicon/languageicon/languageicon.component';
import { LogouticonComponent } from './menuicon/logouticon/logouticon.component';
import { BariconComponent } from './menuicon/baricon/baricon.component';
import { NotifyiconComponent } from './menuicon/notifyicon/notifyicon.component';
import { EmailiconComponent } from './menuicon/emailicon/emailicon.component';
import { SettingiconComponent } from './menuicon/settingicon/settingicon.component';
import { NotifydropdownComponent } from './dropdown/notifydropdown/notifydropdown.component';
import { EmaildropdownComponent } from './dropdown/emaildropdown/emaildropdown.component';
import { QuickdropdownComponent } from './dropdown/quickdropdown/quickdropdown.component';
import { LanguagedropdownComponent } from './dropdown/languagedropdown/languagedropdown.component';

import { MessageinboxComponent } from './common/messageinbox/messageinbox.component';
import { MessageComponent } from './common/message/message.component';
import { SentmessageComponent } from './common/sentmessage/sentmessage.component';
import { DraftmessageComponent } from './common/draftmessage/draftmessage.component';
import { ImportantmessageComponent } from './common/importantmessage/importantmessage.component';
import { TrashmessageComponent } from './common/trashmessage/trashmessage.component';

import { ReplyiconComponent } from './menuicon/replyicon/replyicon.component';
import { ForwardiconComponent } from './menuicon/forwardicon/forwardicon.component';
import { DeleteiconComponent } from './menuicon/deleteicon/deleteicon.component';

import { CreatemessageComponent } from './common/createmessage/createmessage.component';
import { CreatemailComponent } from './common/createmail/createmail.component';
import { EmailComponent } from './common/email/email.component';
import { LoginComponent } from './common/login/login.component';
import { ForgotpasswordComponent } from './common/forgotpassword/forgotpassword.component';
import { RegisterComponent } from './common/register/register.component';
import { DraftemailComponent } from './common/draftemail/draftemail.component';
import { ImportantemailComponent } from './common/importantemail/importantemail.component';
import { SentemailComponent } from './common/sentemail/sentemail.component';
import { TrashemailComponent } from './common/trashemail/trashemail.component';
import { InboxemailComponent } from './common/inboxemail/inboxemail.component';
 import { SublevelMenuComponent } from './menu/sublevel-menu.component';
import { CalenderComponent } from './calender/calender.component';
*/


@NgModule({
  imports: [
    CommonModule,
    MatSelectModule,
    MatSliderModule,
    RouterModule,
    FormsModule,
    ClipboardModule,
    MatIconModule,
    ReactiveFormsModule,
    NgApexchartsModule,
    BrowserModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,
    MatRadioModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    NgxMaskDirective,
    NgxMaskPipe,
    SharedModule


  ],
  declarations: [

    TarifConfigurationComponent,
    ListeTarifConfigurationComponent,
    

    /*HeaderComponent,
    MenuComponent,
    QuickviewComponent,
    UserComponent,
    RecentvoucherComponent,
    RecentclientsComponent,
    CopyrightComponent,
    ProfileComponent,
    BalancealertComponent,
    SplinechartComponent,
    BarchartComponent,
    PiechartComponent,
    
    CreatebankComponent,
    BalancetransferComponent,
    CreatepaymentComponent,
    CreatepaymentinvoiceComponent,
    CreateledgerComponent,
    BanklistComponent,
    PaymentlistComponent,
    PaginationComponent,
    LedgerlistComponent,
    PaymentlistinvoiceComponent,
    TransferlistComponent,
    LedgergroupComponent,
    DebitlistComponent,
    CreditlistComponent,
    PaymentviewpopupComponent,
    PaymentinvoicepopupComponent,
    DebitvoucherComponent,
    CreditvoucherComponent,
    DebitvoucherpopupComponent,
    CreditvoucherpopupComponent,
    CreatejournalComponent,
    JournallistComponent,
    JournalpopupComponent,
    CompanyComponent,
    AddcompanypopupComponent,
    CompanyoverviewpopupComponent,
    SupplierComponent,
    AddsupplierpopupComponent,
    BillerComponent,
    AddbillerpopupComponent,
    AddvendorpopupComponent,
    VendorComponent,
    CustomerComponent,
    AddcustomerpopupComponent,
    AdduserComponent,
    UserlistComponent,
    UserroleComponent,
    ManagebillComponent,
    AddbillComponent,
    AddpaymentpopupComponent,
    SendbillpopupComponent,
    TransectionComponent,
    AccountsbalanceComponent,
    TrialbalanceComponent,
    IncomereportComponent,

    IncomechartsComponent,
    ExpensereportComponent,
    ProfitreportComponent,
    NetincomereportComponent,
    BalancesheetComponent,
    BilldetailspopupComponent,
    RolepermissionComponent,
    BankrolepermissionComponent,
    PaymentrolepermissionComponent,
    VoucherrolepermissionComponent,
    LedgerrolepermissionComponent,
    CompanyrolepermissionComponent,
    PeoplerolepermissionComponent,
    ReportrolepermissionComponent,
    SettingrolepermissionComponent,
    
    DashboardiconComponent,
    BankiconComponent,
    PaymenticonComponent,
    VouchericonComponent,
    LedgericonComponent,
    BilliconComponent,
    CompanyiconComponent,
    SmsiconComponent,
    PeopleiconComponent,
    ReporticonComponent,
    ToolsiconComponent,
    
    CustomeraddbillComponent,
    CustomermanagebillComponent,
    
    EditprofileiconComponent,
    AppearenceiconComponent,
    LanguageiconComponent,
    LogouticonComponent,
    BariconComponent,
    NotifyiconComponent,
    EmailiconComponent,
    SettingiconComponent,
    NotifydropdownComponent,
    EmaildropdownComponent,
    QuickdropdownComponent,
    LanguagedropdownComponent,
    
    MessageinboxComponent,
    MessageComponent,
    SentmessageComponent,
    DraftmessageComponent,
    ImportantmessageComponent,
    TrashmessageComponent,
    
    ReplyiconComponent,
    ForwardiconComponent,
    DeleteiconComponent,
    
    CreatemessageComponent,
    CreatemailComponent,
    EmailComponent,
    LoginComponent,
    ForgotpasswordComponent,
    RegisterComponent,
    DraftemailComponent,
    ImportantemailComponent,
    SentemailComponent,
    TrashemailComponent,
    InboxemailComponent,
    SublevelMenuComponent,
    CalenderComponent */
  ],
  providers: [
    provideNgxMask(),
    { provide: HTTP_INTERCEPTORS, useClass: HttpHeadersInterceptor, multi: true },
    { provide: MatPaginatorIntl, useClass: FrenchPaginatorIntl }
  ]
})
export class TarifModule { }
